import { GetOffices } from './GetOffices'
import {DEFAULT_PAGE} from "../../contstants";

const FilterOffices = async (perPage,filters) => {
    const page = filters.page || DEFAULT_PAGE;
    const status = filters['status[]'] || '';
    let statusFilter = true;
    if(status === 'inactive'){
        statusFilter = false;
    }
    const name = filters.s;
    return await GetOffices(
        {
            limit : perPage,
            offset : (page - 1) * perPage,
            status : statusFilter,
            name : name
        });
};

export default FilterOffices;
